<template>
<v-dialog
  v-model="value"
  max-width="900px"
  persistent
  scrollable
  content-class="competencies-dialog"
>
  <v-card class="rounded-lg" style="border-radius: 12px !important; overflow: hidden;">
    <v-card-title class="d-flex justify-space-between align-center px-6 py-4 border-b" style="border-bottom: 1px solid #e0e0e0;">
      <div>
        <div class="d-flex justify-end">
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <h2 class="text-h6 font-weight-bold grey--text text--darken-3 mb-1">
          Библиотека компетенций
        </h2>
        <div class="text-body-2 grey--text">
          Редактируйте, удаляйте или добавляйте компетенции — изменения сохраняются локально и применяются при создании диагностики.
        </div>
      </div>
    </v-card-title>

    <v-card-text class="px-6 py-4">
      <div class="d-flex align-center gap-2" style="gap: 12px;">
        <v-text-field
          v-model="search"
          dense
          outlined
          hide-details
          placeholder="Поиск по названию или описанию"
          prepend-inner-icon="mdi-magnify"
          class="flex-grow-1 custom-search-modal"
          style="max-width: 100%;"
        ></v-text-field>
        <v-btn
          color="#009E60"
          dark
          depressed
          class="text-capitalize px-6"
          height="40"
          @click="openEditCompetencyModal(null)"
        >
          <v-icon left small>mdi-plus</v-icon> Новая
        </v-btn>
      </div>
    </v-card-text>

    <v-card-text class="px-6 py-0" style="min-height: 500px; max-height: 500px; overflow-y: auto;">
      <v-row v-if="isSearching || !libraryCompetencies || !libraryCompetencies.length">
        <v-col
          v-for="(competency, index) in 4"
          :key="index"
          cols="12"
        >
          <CardItemSkeleton
            :data="competency"
            :type="'competence'"
            :action="false"
          />
        </v-col>
      </v-row>
      <v-row v-else-if="filteredCompetencies && filteredCompetencies.length">
        <v-col
          v-for="competency in filteredCompetencies"
          :key="competency.id"
          cols="12"
        >
          <CardItem
            :data="competency"
            :type="'competenciesModal'"
            :action="true"
            @edit="openEditCompetencyModal(competency.id)"
            @delete="deleteItemCompetency(competency)"
          />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12" class="text-center grey--text py-6">
          Ничего не найдено
        </v-col>
      </v-row>

    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions class="px-6 py-4 d-flex justify-space-between">
      <v-btn
        text
        color="grey darken-2"
        class="text-capitalize"
        @click="$emit('reset')"
      >
        <v-icon left small>mdi-refresh</v-icon> Сбросить всё
      </v-btn>

      <v-btn
        color="#009E60"
        dark
        depressed
        class="text-capitalize px-8"
        height="40"
        @click="$emit('submit')"
      >
        Готово
      </v-btn>
    </v-card-actions>
  </v-card>

</v-dialog>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CardItem from '../Admin/CardItem.vue';
import CardItemSkeleton from '../Admin/CardItemSkeleton.vue';

export default {
  name: 'CompetenciesModal',
  components: { CardItemSkeleton, CardItem },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      libraryCompetencies: 'diagnostics/diagnotics/libraryCompetencies'
    }),
    filteredCompetencies() {
      const q = this.debouncedSearch.trim().toLowerCase();
      if (!q) return this.libraryCompetencies;
      return this.libraryCompetencies.filter(c =>
        (c.name || '').toLowerCase().includes(q) || (c.description || '').toLowerCase().includes(q)
      );
    },
  },
  watch: {
    search() {
      this.isSearching = true;
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.debouncedSearch = this.search;
        this.isSearching = false;
      }, 300);
    },
  },
  beforeDestroy() {
    clearTimeout(this.searchDebounceTimer);
  },
  methods: {
    ...mapActions({
      openEditCompetency: 'diagnostics/diagnotics/openEditCompetency',
      openCreateCompetency: 'diagnostics/diagnotics/openCreateCompetency',
      deleteCompetency: 'diagnostics/diagnotics/deleteItemCompetency',
    }),
    ...mapMutations({
      SET_COMPETENCIES_MODAL: 'diagnostics/diagnotics/SET_COMPETENCIES_MODAL',
      SET_COMPETENCY_SHOW_MODAL: 'diagnostics/diagnotics/SET_COMPETENCY_SHOW_MODAL',
      SET_COMPETENCY_ID_MODAL: 'diagnostics/diagnotics/SET_COMPETENCY_ID_MODAL'
    }),
    closeModal() {
      this.SET_COMPETENCIES_MODAL(false);
    },
    openEditCompetencyModal(id) {
      try {
        if (id) {
          this.openEditCompetency(id);
        } else {
          this.openCreateCompetency();
        }
      } catch (err) {
        this.$toast.error('Ошибка,попробуйте позже...', '', { position: 'topRight' });
      }
    },
    async deleteItemCompetency(competency) {
      console.log(competency);
      await this.deleteCompetency(competency.id);
    },
  },
  data() {
    return {
      search: '',
      debouncedSearch: '',
      isSearching: false,
      searchDebounceTimer: null,
    };
  }
};
</script>

<style lang="scss">
/* Стилизация диалога */
.competencies-dialog {
  max-height: 90vh;
}

/* Кастомный стиль для поиска в модалке */
.custom-search-modal {
  .v-input__slot {
    border-radius: 8px !important;
    border: 1px solid #009E60 !important; /* Зеленая обводка как на макете */
    box-shadow: none !important;
    background-color: #ffffff !important;
    min-height: 40px !important;
  }

  .v-input__icon--prepend-inner .v-icon {
    color: #9e9e9e;
  }

  input::placeholder {
    color: #a0a0a0;
    font-size: 14px;
  }

  /* При фокусе - усиление рамки */
  &.v-input--is-focused .v-input__slot {
    border-width: 2px !important;
  }
}

/* Стилизация скроллбара */
.v-card__text::-webkit-scrollbar {
  width: 6px;
}
.v-card__text::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.v-card__text::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 4px;
}
.v-card__text::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}
</style>
